import { createSelector } from '@reduxjs/toolkit';

export const itineraryRelocationsSelector = (state) => state.itinerariesItem?.relocations || [];

export const itineraryCurrentRelocationSelector = createSelector(
  [itineraryRelocationsSelector, (state, itemIndex) => itemIndex],
  (relocations, itemIndex) => {
    return relocations[itemIndex];
  },
);
